module.exports = __webpack_public_path__ + "img/link.271ab092.svg";